<template>
  <popup :opened="dataToShow" @close="close">
    <message-header :message-header="messageHeader" />

    <div class="sticky top-0 z-10">
      <!-- Save button -->
      <div
        v-if="saving"
        class="absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
      >
        <span class="h-6 w-6 ml-4 mt-1/4 spinner spinner-save" />
      </div>
      <div
        v-else
        class="absolute w-14 h-14 right-1 mt-13 mr-13 rounded-full cursor-pointer bg-pink-600 hover:shadow-pink text-white"
        @click="save"
      >
        <icon name="save" class="h-6 w-6 ml-4 mt-1/4" />
      </div>
    </div>

    <!-- BEGIN Content modal modify referent -->
    <div class="m-5 lg:m-15 2xl:m-20">
      <h3>
        Modifier le compte référent de <br />
        {{ adminToEdit.firstname }}
        <span class="uppercase">{{ adminToEdit.lastname }}</span>
      </h3>
      <div class="w-full flex justify-center my-10">
        <!--<img
                class="h-36 w-36 rounded-full"
                src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80"
                alt=""
                /> -->
        <ProfilePicture
          size="max-w-36 w-36 h-36"
          :other-object="adminToEdit"
          :show-edit-link="true"
        />
      </div>

      <!--<div class="cursor-pointer font-medium  w-full text-center text-2sm italic text-pink-600">Changer d'image</div>-->

      <div class="flex justify-center mb-10">
        <div class="border-dashed border-gray-300 border-2 rounded-lg">
          <div class="my-4 mx-8">
            <p class="text-sm italic font-medium text-gray-600">
              Nom d'utilisateur
            </p>
            <h4 class="text-indigo-600">
              {{ adminToEdit.username }}
            </h4>
          </div>
        </div>
      </div>

      <div class="my-10 w-full">
        <div class="grid grid-cols-12 gap-x-4 gap-y-5 xl:mx-1/10">
          <input-text
            class="lg:col-span-6"
            name="firstname"
            libelle="Prénom"
            :value="adminToEdit.firstname"
            @input="
              (newValue) => {
                adminToEdit.firstname = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.firstname'] || [])[0]"
          />
          <input-text
            class="lg:col-span-6"
            name="lastname"
            libelle="Nom"
            :value="adminToEdit.lastname"
            @input="
              (newValue) => {
                adminToEdit.lastname = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.lastname'] || [])[0]"
          />
          <input-text
            class="lg:col-span-6"
            name="company"
            libelle="Entreprise"
            :value="((adminToEdit.companies || [])[0] || {}).name"
          />
          <input-text
            class="lg:col-span-6"
            name="fonction"
            libelle="Fonction"
            :value="
              (((adminToEdit.companies || [])[0] || {}).pivot || {}).function
            "
            @input="
              (newValue) => {
                (
                  ((adminToEdit.companies || [])[0] || {}).pivot || {}
                ).function = newValue;
              }
            "
          />
          <input-text
            class="lg:col-span-6"
            name="email"
            type="email"
            libelle="Email"
            :value="adminToEdit.email"
            @input="
              (newValue) => {
                adminToEdit.email = newValue;
              }
            "
            :error="true"
            :msg-error="((errors || [])['user.email'] || [])[0]"
          />
          <input-text
            class="lg:col-span-6"
            name="phone_number"
            libelle="Téléphone"
            :value="adminToEdit.telephone"
            @input="
              (newValue) => {
                adminToEdit.telephone = newValue;
              }
            "
            :error="true"
            type="tel"
          />
          <input-text-area
            class="lg:col-span-full"
            name="address"
            libelle="Adresse postale"
            :value="adminToEdit.address"
            @input="
              (newValue) => {
                adminToEdit.address = newValue;
              }
            "
          />
        </div>
      </div>
    </div>
    <!-- END Content modal modify referent -->
  </popup>
</template>

<script>
import { mapGetters } from 'vuex';
import axios from './../../api';
import Popup from './../../components/Popup.vue';
import MessageHeader from './../../components/MessageHeader';
import Icon from './../../components/Icon';
import InputText from './../../components/Inputs/InputText';
import InputTextArea from './../../components/Inputs/InputTextArea';

import Constants from './../../constants';
import ProfilePicture from './../../components/ProfilePicture.vue';

export default {
  name: 'EditAdminPopup',

  props: {
    dataToShow: Boolean,
    adminToEdit: Object,
  },

  data() {
    return {
      constants: Constants,
      errors: [],
      messageHeader: {},
      saving: false,
    };
  },

  components: {
    ProfilePicture,
    Popup,
    MessageHeader,
    Icon,
    InputText,
    InputTextArea,
  },

  methods: {
    close() {
      this.$emit('close');
    },

    async save() {
      this.saving = true;
      await axios
        .put('api/users/' + this.adminToEdit.id, { user: this.adminToEdit })
        .then(() => {
          this.messageHeader = {
            type: 'success',
            msg:
              "Les informations de l'administrateur " +
              this.adminToEdit.firstname +
              ' ' +
              this.adminToEdit.lastname +
              ' ont bien été modifiées',
          };
          this.saving = false;
          this.errors = [];
          setTimeout(() => {
            this.messageHeader = {};
          }, 3000);
        })
        .catch((error) => {
          console.log('ERRRR:: ', error);
          this.saving = false;
          this.errors = error.response.data.errors;
          this.messageHeader = {
            type: 'error',
            msg: "Erreur d`'enregistrement des données.",
          };
          setTimeout(() => {
            this.messageHeader = {};
          }, 3000);
        });
    },
  },

  computed: {
    ...mapGetters({
      structure: 'auth/structure',
    }),
  },
};
</script>
